namespace TabAurous.Sales {
    export interface ApprovalOutReturnRow {
        TransId?: number;
        TransDate?: string;
        RefTransId?: number;
        VoucherNo?: string;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        VoucherTypeId?: number;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: ApprovalOutReturnItemsRow[];
        DepartmentId?: number;
        RefVoucherId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace ApprovalOutReturnRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Sales.ApprovalOutReturn';
        export const deletePermission = 'Sales:ApprovalReturn:Delete';
        export const insertPermission = 'Sales:ApprovalReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:ApprovalReturn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            RefTransId = "RefTransId",
            VoucherNo = "VoucherNo",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            DepartmentId = "DepartmentId",
            RefVoucherId = "RefVoucherId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
